import React from "react";
import {Button} from "@amzn/awsui-components-react";
import {
  FILTER_TYPE,
  newCalcDetailFromType,
  SOURCE_TYPE
} from "../CalcDetails";
import {StepCard} from "./StepCard";

import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import FlipMove from 'react-flip-move';

class TransformStepCardView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {columns: {}};
  }

  cardStateReplacer(ind, data) {
    let calcDef = [...this.props.data];
    const oldType = this.props.data[ind].calc_type;
    calcDef[ind] = data;
    if (data.calc_type === SOURCE_TYPE ) {
      if (oldType !== SOURCE_TYPE) {
        let nonSource = this.props.data.findIndex(x => x.calc_type !== SOURCE_TYPE);
        calcDef = this.rearrange(calcDef, ind, nonSource);
      }
    } else {
      let count = 0;
      while (count < calcDef.length && (ind === count || calcDef[count].calc_type === SOURCE_TYPE)) {
        count++;
      }
      if (ind < count) {
        calcDef = this.rearrange(calcDef, ind, count - 1);
      }
    }
    this.props.onChange(calcDef);
  }

  cardStateRemover(ind) {
    const calcDef = [...this.props.data];
    calcDef.splice(ind, 1);
    this.props.onChange(calcDef);
  }

  cardStateAdder() {
    const calcDef = [...this.props.data];
    calcDef.splice(calcDef.length - 1, 0, newCalcDetailFromType(FILTER_TYPE));
    this.props.onChange(calcDef);
  }

  // Rearrange calcData, inserting the item at ind0 at ind1 and shifting list down
  rearrange(calcData, ind0, ind1) {
    const calcDef = [...calcData];
    const toReinsert = calcDef[ind0];
    calcDef.splice(ind0, 1);
    calcDef.splice(ind1, 0, toReinsert);
    return calcDef
  }

  cardRearranger(ind0, ind1) {
    const calcDef = this.rearrange(this.props.data, ind0, ind1);
    this.props.onChange(calcDef);
  }

  render() {
    if (this.props.loading) {
      return <div>Loading...</div>
    }
    if (!this.props.loading && !this.props.initialized) {
      return <div>Issue loading data</div>
    }

    return <React.Fragment>
      <FlipMove>
      {this.props.data.map(item => <StepCard
        item={item}
        data={this.props.data}
        cardRearranger={(ind0, ind1) => this.cardRearranger(ind0, ind1)}
        cardStateReplacer={(ind, data) => this.cardStateReplacer(ind, data)}
        cardStateRemover={(ind) => this.cardStateRemover(ind)}
        columnMetadata={this.props.columnMetadata}
        key={item.guid}
        controlDisabled={this.props.saving}
      />)}
      </FlipMove>
      <Button onClick={() => this.cardStateAdder()} disabled={this.props.saving}>
        Create New
      </Button>
    </React.Fragment>;
  }
}

const mapStateToProps = (state) => {

  const {fetchColumnMetadata} = state;
  const {columnMetadata, loading, error, initialized} = fetchColumnMetadata;
  const {saving} = state.saveCalcDetailsData;

  return {
    loading: loading,
    columnMetadata: columnMetadata,
    error: error,
    initialized: initialized,
    saving: saving
  };
};

const mapDispatchToProps = {};

const TransformStepCardViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransformStepCardView);

const comp = withRouter(TransformStepCardViewContainer);
export {comp as TransformStepCardView};

